import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private _isLoggedIn: boolean = false;
  constructor(private router: Router) {}

  isLoggedIn() {
    return this._isLoggedIn;
  }

  login({ username, password }): boolean {
    if (username === "callop" && password === "cc123456") {
      this._isLoggedIn = true;
      this.router.navigateByUrl("/admin/cargar-listas-negocio");
      return true;
    }

    return false;
  }

  logout() {
    this._isLoggedIn = false;
    this.router.navigateByUrl("/auth/login");
  }
}
